// extracted by mini-css-extract-plugin
export default {"container":"splashScreen_container__xi87t","content":"splashScreen_content__sSvqo"};